/**
 * Accessible name for the grade span inside an editable cell when the visible
 * value is the standard missing-score placeholder from formatGradePercent / formatGradePoints.
 *
 * @param {unknown} formattedGrade — String from formatters, or JSX (e.g. UngradedIcon)
 * @returns {string|undefined} — `undefined` means omit aria-label on the span
 */
export function getGradeDisplaySpanAriaLabel(formattedGrade) {
  if (typeof formattedGrade === 'string' && formattedGrade === '--') {
    return 'Score not available';
  }
}
